import axios from "axios";
import React, {useEffect, useState, useRef, Fragment} from "react";
import {Link, NavLink, useParams, useNavigate, useLocation} from "react-router-dom"
import {render} from "react-dom";
import clientconfigwebapp, {
    empty_bk,
    convert_to_english_strhk,
    scrollTo_uphk,
    check_login_appbk,
    Token_get_appbk,
    redirectbh_typeb,
    getLengt_arraybk, FormatNumberByhkh,Get_Weight_txt_bk
} from '../../../clientconfigwebapp';
import {ToastContainer, toast} from 'react-toastify';

import Master_Front_Buyer from "../../Master_Front_Buyer";


import ReactFullPageLoadinghk from "../../../components/layaout/LoadingFullpagehk";


import '../../../components/assets/css/profile.css'


import serialize from "form-serialize";
import Grid from "@mui/material/Grid";
import Category_Selector_Large from "../../../components/CategorySelector/Category_Selector_Large";
import {Information} from "../../../assets/icones/icones";



const List_My_Requests = (props) => {

    const location = useLocation()


    const location_get_urlbk = useLocation();
    const redirect_navigate = useNavigate();
    const [loadinghkfullshow, Setloadinghkfullshow] = useState("false");

    /*  start profile */
    const [wallet_balance, setData_wallet_balance] = useState('0');
    const [first_name_profile, setData_first_name_profile] = useState('');
    const [last_name_profile, setData_last_name_profile] = useState('');
    const [profile_src, setData_profile_src] = useState('');
    const [type_user_panel, setData_type_user_panel] = useState('');
    /*  end profile */


    const [data_list_posts, setData_data_list_posts] = useState([]);
    const [active_tab_curent, set_active_tab_curent] = useState("tab1");


    useEffect(() => {
        scrollTo_uphk();
        if (check_login_appbk() == false) {
            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login-register" );
            return false;
        }
        Load_api_page('pending');

    }, [location_get_urlbk]);

    const Load_api_page = (filter_status) => {

        if (check_login_appbk() == false) {
            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login-register");
        }

        const config = {
            headers: {Authorization: `Bearer ${Token_get_appbk()}`}
        };


        Setloadinghkfullshow("true");


        let form_data = document.querySelector('#form_search');
        if (form_data != null) {
            let formDatanew = new FormData(form_data);

            if(String(filter_status)=="pending"){ formDatanew.append("filter_status", "pending"); set_active_tab_curent("tab1");  }
            if(String(filter_status)=="approved"){ formDatanew.append("filter_status", "approved");  set_active_tab_curent("tab2"); }
            if(String(filter_status)=="declined"){ formDatanew.append("filter_status", "declined");  set_active_tab_curent("tab3"); }

            setData_data_list_posts([]);



            let data_serialize = new URLSearchParams(formDatanew).toString();


            /// let data_serialize = serialize(form_data);


            axios.post(`${clientconfigwebapp.siteurl}api/v1/panel/my-requests/`, data_serialize, config)


                .then((res) => {
                    Setloadinghkfullshow("false");
///console.log(res.data);



                    if (String(res.data.data).length > 0) {

                        if (String(res.data.data) == "login-show") {
                            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login-register");
                        }

                        if (!empty_bk(res.data.type_user)) { setData_type_user_panel(res.data.type_user); }

                        if (String(res.data.wallet_inventory).length > 0) {
                            setData_wallet_balance(res.data.wallet_inventory);
                        }
                        if (!empty_bk(res.data.first_name_profile)) {
                            setData_first_name_profile(res.data.first_name_profile);
                            localStorage.setItem('first_name_Get', res.data.first_name_profile);
                        }
                        if (!empty_bk(res.data.last_name_profile)) {
                            setData_last_name_profile(res.data.last_name_profile);
                            localStorage.setItem('last_name_Get', res.data.last_name_profile);
                        }
                        if (!empty_bk(res.data.profile_src)) {
                            setData_profile_src(res.data.profile_src);
                        }








                      if(getLengt_arraybk(res.data.data_list_posts) > 0 ) {  setData_data_list_posts(res.data.data_list_posts); }else{  setData_data_list_posts([]);  }






                    } else {
                        Setloadinghkfullshow("false");
                        if (String(res.data.msgwebapp).length > 0) toast.error(res.data.msgwebapp, {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }

                }).catch((err) => {
                Setloadinghkfullshow("false");
                toast.error('خطا اتصال به سرور کد  435346', {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });


        }


    }







    return (<Fragment>

        <Master_Front_Buyer type_user_panel={type_user_panel} wallet_balance={wallet_balance} first_name_profile={first_name_profile} last_name_profile={last_name_profile} profile_src={profile_src}>
            <ReactFullPageLoadinghk loadinghk={loadinghkfullshow}/>
            <ToastContainer/>


            <div className={"box-content-panelbk"}>

                <span className={"title-box-content-panel"}>درخواست ها</span>

                <div className={"container-bk"}>
                    <form id={"form_search"} name={"form_search"} encType="multipart/form-data" style={{width: "100%"}}>


                        <div className='flexRowStartCenter tab-header-bk'>


                            <button type={"button"} onClick={() => {  Load_api_page('pending'); } }
                                    className={(() => {

                                        if (String(active_tab_curent) == "tab1") {
                                            return ' btn-tab-navbk flexRowStartCenter tab-active-bk ';
                                        } else {

                                            return ' btn-tab-navbk flexRowStartCenter';
                                        }
                                    })()

                                    }><span>در انتظار تایید</span>
                            </button>


                            <button type={"button"} onClick={() =>  {  Load_api_page('approved'); }}
                                    className={(() => {

                                        if (String(active_tab_curent) == "tab2") {
                                            return ' btn-tab-navbk flexRowStartCenter tab-active-bk ';
                                        } else {

                                            return ' btn-tab-navbk flexRowStartCenter';
                                        }
                                    })()

                                    }>
                                <span>تایید شده</span>
                            </button>


                            <button type={"button"} onClick={() =>  {  Load_api_page('declined'); }}
                                    className={(() => {

                                        if (String(active_tab_curent) == "tab3") {
                                            return ' btn-tab-navbk flexRowStartCenter tab-active-bk ';
                                        } else {

                                            return ' btn-tab-navbk flexRowStartCenter';
                                        }
                                    })()

                                    }>
                                <span>رد شده</span>
                            </button>


                        </div>


                 <div style={{"display":"flex","flexDirection":"row","alignContent":"center","justifyContent":"flex-end","alignItems":"center",marginBottom:"10px"}}>
                     <Link className={"btn-bk-new btn-bk-new-blue"} reloadDocument={true} to={"/panel/request-reg"}>
                         <svg width={24} height={24} viewBox="0 0 24 24" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                             <g clipPath="url(#clip0_0_3035)">
                                 <path
                                     d="M13 7H11V11H7V13H11V17H13V13H17V11H13V7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
                                     fill="white"/>
                             </g>
                             <defs>
                                 <clipPath id="clip0_0_3035">
                                     <rect width={24} height={24} fill="white"/>
                                 </clipPath>
                             </defs>
                         </svg>
                         <span>ثبت درخواست</span>


                     </Link>
                 </div>


                        {data_list_posts && data_list_posts.length > 0 ? (

                            <div className="box_full_table_typea_bk_v1">

                                <div className="table_typea_bk" style={{backgroundColor: "transparent"}}>
                                    <div className="table_typea_bk_theader" style={{backgroundColor: "#f1f1f1"}}>
                                        <div className="table_typea_bk_header">ردیف</div>
                                        <div className="table_typea_bk_header">نوع محصول</div>
                                        <div className="table_typea_bk_header">وضعیت</div>
                                        <div className="table_typea_bk_header">میزان سفارش</div>
                                        <div className="table_typea_bk_header">تاریخ</div>

                                    </div>


                                    {


                                        data_list_posts.map((item_post, index) => {


                                            return (


                                                <div className="table_typea_bk_row">


                                                    <div className="table_typea_bk_small">
                                                        <div className="table_typea_bk_cell">ردیف</div>
                                                        <div className="table_typea_bk_cell">
                                                            <span>{parseInt(index) + 1} </span>
                                                        </div>
                                                    </div>

                                                    <div className="table_typea_bk_small">
                                                        <div className="table_typea_bk_cell">نوع محصول</div>
                                                        <div className="table_typea_bk_cell">
                                                            <div>
                                                                {item_post.category_step3_text_end} | {item_post.product_type_text}

                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div className="table_typea_bk_small">
                                                        <div className="table_typea_bk_cell">وضعیت</div>

                                                        <div className="table_typea_bk_cell">


                                                            {
                                                                item_post.status_publish == "pending" ? (<Fragment>
                                                                    <div style={{
                                                                        "display": "inline-block",
                                                                        "padding": "5px",
                                                                        "borderRadius": "7px",
                                                                        "backgroundColor": "#FFEBCE",
                                                                        "color": "#FF9D09",
                                                                        "minWidth": "107px"
                                                                    }}>در انتظار تایید
                                                                    </div>
                                                                </Fragment>) : (<Fragment></Fragment>)
                                                            }


                                                            {
                                                                item_post.status_publish == "approved" ? (<Fragment>
                                                                    <div style={{
                                                                        "display": "inline-block",
                                                                        "padding": "5px",
                                                                        "borderRadius": "7px",
                                                                        "backgroundColor": "#E6F9F5",
                                                                        "color": "#00C193",
                                                                        "minWidth": "107px"
                                                                    }}>تایید شده
                                                                    </div>
                                                                </Fragment>) : (<Fragment></Fragment>)
                                                            }


                                                            {
                                                                item_post.status_publish == "declined" ? (<Fragment>
                                                                    <div style={{
                                                                        "display": "inline-block",
                                                                        "padding": "5px",
                                                                        "borderRadius": "7px",
                                                                        "backgroundColor": "#FBE8E8",
                                                                        "color": "#E50000",
                                                                        "minWidth": "107px"
                                                                    }}>رد شده
                                                                    </div>
                                                                </Fragment>) : (<Fragment></Fragment>)
                                                            }


                                                        </div>

                                                    </div>


                                                    <div className="table_typea_bk_small">
                                                        <div className="table_typea_bk_cell">میزان سفارش</div>
                                                        <div className="table_typea_bk_cell">
                                                            <span> {Get_Weight_txt_bk(item_post.order_amount)}  </span>
                                                        </div>
                                                    </div>


                                                    <div className="table_typea_bk_small">
                                                        <div className="table_typea_bk_cell">تاریخ</div>
                                                        <div className="table_typea_bk_cell"
                                                             style={{"direction": "ltr"}}>
                                                            <span>{item_post.date_reg}</span>

                                                        </div>
                                                    </div>


                                                </div>


                                            )

                                        })

                                    }


                                </div>
                            </div>

                        ) : (<Fragment>



                        <div style={{"display":"flex","textAlign":"center","paddingBottom":"32px","paddingTop":"32px","flexDirection":"column","flexWrap":"nowrap","alignContent":"center","alignItems":"center"}}>

   <svg width={35} height={35} viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15.5007 5.16675C14.1304 5.16675 12.8162 5.71109 11.8473 6.68003C10.8783 7.64897 10.334 8.96313 10.334 10.3334V51.6668C10.334 53.037 10.8783 54.3512 11.8473 55.3201C12.8162 56.2891 14.1304 56.8334 15.5007 56.8334H46.5006C47.8709 56.8334 49.1851 56.2891 50.154 55.3201C51.123 54.3512 51.6673 53.037 51.6673 51.6668V20.6667L36.1673 5.16675H15.5007ZM15.5007 10.3334H33.584V23.2501H46.5006V51.6668H15.5007V10.3334ZM20.6673 31.0001V36.1667H41.334V31.0001H20.6673ZM20.6673 41.3334V46.5001H33.584V41.3334H20.6673Z"
            fill="#9CA3AF"/>
      </svg>


                            {active_tab_curent === "tab1" ? (
                                <Fragment>
                                    <div style={{"fontFamily":"'iran'","marginTop":"8px","marginBottom":"4px","fontSize":"17px","color":"#4f4f4f"}}>درخواستی با وضعیت در انتظار تایید، ثبت نشده است!</div>
                                    <div style={{"fontSize":"14px","marginTop":"6px","display":"block","color":"#8e9a9d"}}>بعد از ثبت درخواست، در انتظار تایید، توسط کارشناسان باشید.</div>
                                </Fragment>
                            ) : null
                            }


                            {active_tab_curent === "tab2" ? (
                                <div style={{"fontFamily":"'iran'","marginTop":"8px","marginBottom":"4px","fontSize":"17px","color":"#4f4f4f"}}>درخواستی با وضعیت تایید شده، ثبت نشده است! </div>
                            ) : null
                            }


                            {active_tab_curent === "tab3" ? (
                                <div style={{"fontFamily":"'iran'","marginTop":"8px","marginBottom":"4px","fontSize":"17px","color":"#4f4f4f"}}>درخواستی با وضعیت رد شده، ثبت نشده است! </div>
                            ) : null
                            }

                        </div>


                        </Fragment>)

                        }


                    </form>
                </div>

            </div>



        </Master_Front_Buyer>
    </Fragment>);
}


export default List_My_Requests;